import { Injectable } from '@angular/core'

@Injectable({
  providedIn: 'root',
})
export class DownloadService {
  async download(files: { url: string, name: string }[], count = 0) {
    if(count >= files.length) {
      return
    }

    //wait after download
    const link = document.createElement('a')
    link.download = files[count].name
    link.href = files[count].url

    document.body.appendChild(link)
    link.click()
    await new Promise((res) => setTimeout(res, 500))
    document.body.removeChild(link)
    await this.download(files, count+1)
  }
}